/* esm.sh - applesauce-signers@5.2.0/signers/private-key-signer */
export * from "/*applesauce-signers@5.2.0/esnext/signers/private-key-signer.mjs";
